// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2nnnM","log":"ModalInventoryLogs_log__4elvI","date":"ModalInventoryLogs_date__2xb7_","userName":"ModalInventoryLogs_userName__nZ2-6"};